import { render, staticRenderFns } from "./DeliveryTemplate.vue?vue&type=template&id=b01f1b0e&scoped=true&"
import script from "./DeliveryTemplate.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTemplate.vue?vue&type=style&index=0&id=b01f1b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01f1b0e",
  null
  
)

export default component.exports